import type { FormFieldData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";
import type { ContractExtension } from "../Direktvermarktung.types";

export const DIREKTVERMARKTUNG_CONTRACT_EXTENSION_FORM_DATA = {
  last_date: {
    name: "last_date",
    label: "Neues Enddatum",
    type: "date",
    required: true
  }
} as const satisfies FormFieldData<ContractExtension>;
